




















































import { mapState } from "vuex";
import { Component, Watch, Vue } from "vue-property-decorator";
import RouteTranslations from "@/locales/routerTranslations";
import Avatar from "../Avatar.vue";
import { User } from "@/models/user";
import Cellar from "@/models/cellar";
import { RootState } from "@/store";

@Component({
  components: {
    Avatar
  },
  computed: {
    ...mapState({
      user: (state: any) => state.session.user
    })
  }
})
export default class ProfileWidget extends Vue {
  translations: any = RouteTranslations;
  user!: User;
  phoneWidth = false;
  bgAvatarColor: string = "$red";

  mounted() {
    if (window.innerWidth) if (window.innerWidth < 480) this.phoneWidth = true;
  }

  logout() {
    this.$store
      .dispatch("session/logout")
      .then((): any => this.$router.replace(this.$route.path))
      .catch((error: Error) => {
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red"
        });
        this.$store.commit("session/cleanCurrentUser");
        // this.$router.push(`/${this.$i18n.locale}/login`);
      });
  }

  goToUrl(link: string) {
    const toRoute: string = this.translations[this.$i18n.locale][link].link;
    this.$router.push({ path: toRoute });
  }
}
